import { useContext, useState } from 'react'
import TokenContext from './TokenContext'
import { confiUrl } from './tekenConfig'

export const GetToken = () => {
  const token = useContext(TokenContext)
  const [emailSentStatus, setEmailSentStatus] = useState({})
  const [emailField, setEmailField] = useState()
  const getTokenRest = () => {
    fetch(confiUrl.GET_TOKEN_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email: emailField })
    }).then(r => {
      console.log(r)
      if (r.success) {
        setEmailSentStatus({ success: true, status: r.code })
      } else {
        setEmailSentStatus({ success: false, error: true, status: r.code })
      }
    })
  }
  return <div>
    <input type={'email'} onChange={(e)=> setEmailField(e.target.value)} value={emailField}/>
    <button onClick={getTokenRest}>GET TOKEN</button>
    <div>
      Token: {token}
    </div>
    {emailSentStatus && emailSentStatus.success && <div>
      ✔ email sent
    </div>}
    {emailSentStatus && emailSentStatus.error && <div>
      ❗ email error
    </div>}
  </div>
}